import { render, staticRenderFns } from "./DynamicStep.vue?vue&type=template&id=06c0a902&"
import script from "./DynamicStep.vue?vue&type=script&lang=js&"
export * from "./DynamicStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports